import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientRehabImpMarketsParameter  extends Parameter {

    searchTerm: number;
    orderBy: string;

}
export interface PatientRehabImpMarkets {
    id?: number;
    date: Date;   
    description: any;
    notes:string;
    result:string;
    admissionId:any;
    physicianId:string;
    endDate:Date;
    duration?:number;
    therapist:string;
    visitId:any;
    regId: string;     
    tenantId: any;
    branchId: any;
    //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientRehabImpMarketsParameter[];
    links?: any;
    pcId?:number;
    TherapistName?:string;
    performingDoctor?:string;
    performingNurse?:string;
}
export abstract class PatientRehabImpMarketsData { 

    abstract list(url: string): Observable<PatientRehabImpMarkets[]>;
    abstract create(url: string, data: PatientRehabImpMarkets): Observable<any>;
    abstract update(url: string, data: PatientRehabImpMarkets): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}